import { useEffect } from "react";

import Footer from "./Footer";
import Navbarsticky from "./NavbarSticky";

const ReveloLayout = ({ children, sideBar }) => {
 
  return (
    <div className={`page-wrapper ${sideBar ? "for-sidebar-menu" : ""}`}>
      <Navbarsticky/>
      <div className="ferrybooking-container"></div>
      {children}
     <Footer/>
    </div>
  );
};
export default ReveloLayout;
